export default __webpack_public_path__ + "static/media/Eldor2.c24f5d60.png";